import { FC } from 'react'
import { Tab as MUITab, TabProps } from '@mui/material'

export const Tab: FC<TabProps> = props => {
  return <MUITab {...props} />
}
